module.exports = __webpack_public_path__ + "img/dashboard.06818fb8.svg";